import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import "../node_modules/jquery/dist/jquery.min.js";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css'
import {initializeFirebase} from "./firebase";
import {initializePush} from "./initialize";


ReactDOM.render(<App/>, document.getElementById('root'));
initializeFirebase();
initializePush();
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js